import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { BuildingIcon, UsersIcon, AwardIcon, HeartIcon, CheckIcon } from 'lucide-react';
const CorporatePartnerships = () => {
  return <div className="min-h-screen bg-white" data-id="element-4329">
      <PageHeader title="Corporate Partnerships" description="Partner with Isonyin Grammar School to make a lasting impact on education while achieving your corporate social responsibility goals." backgroundImage="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Support',
      path: '/support'
    }, {
      label: 'Corporate Partnerships',
      path: '/support/corporate-partnerships'
    }]} data-id="element-4330" />
      <div className="container mx-auto px-4 py-12" data-id="element-4331">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-4332">
          <div data-id="element-4333">
            <h2 className="text-3xl font-bold text-blue-900 mb-6" data-id="element-4334">
              Why Partner With Us?
            </h2>
            <p className="text-gray-700 mb-8" data-id="element-4335">
              A partnership with Isonyin Grammar School offers your organization
              the opportunity to make a meaningful contribution to education
              while enhancing your brand's reputation and fulfilling your
              corporate social responsibility objectives.
            </p>
            <div className="space-y-6" data-id="element-4336">
              <div className="flex items-start" data-id="element-4337">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-4338">
                  <HeartIcon className="h-6 w-6 text-blue-700" data-id="element-4339" />
                </div>
                <div data-id="element-4340">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-4341">
                    Community Impact
                  </h3>
                  <p className="text-gray-700" data-id="element-4342">
                    Make a tangible difference in the local community by
                    investing in the education of future leaders.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-4343">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-4344">
                  <BuildingIcon className="h-6 w-6 text-blue-700" data-id="element-4345" />
                </div>
                <div data-id="element-4346">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-4347">
                    Brand Association
                  </h3>
                  <p className="text-gray-700" data-id="element-4348">
                    Associate your brand with a respected educational
                    institution with over 50 years of excellence.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-4349">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-4350">
                  <UsersIcon className="h-6 w-6 text-blue-700" data-id="element-4351" />
                </div>
                <div data-id="element-4352">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-4353">
                    Employee Engagement
                  </h3>
                  <p className="text-gray-700" data-id="element-4354">
                    Create meaningful volunteer opportunities for your employees
                    to contribute their skills and time.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-4355">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-4356">
                  <AwardIcon className="h-6 w-6 text-blue-700" data-id="element-4357" />
                </div>
                <div data-id="element-4358">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-4359">Recognition</h3>
                  <p className="text-gray-700" data-id="element-4360">
                    Receive recognition and visibility through our various
                    communication channels and events.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg" data-id="element-4361">
            <h2 className="text-3xl font-bold text-blue-900 mb-6" data-id="element-4362">
              Partnership Opportunities
            </h2>
            <div className="space-y-6" data-id="element-4363">
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-4364">
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-4365">
                  Infrastructure Development
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-4366">
                  Support the construction or renovation of school facilities
                  with naming rights and recognition.
                </p>
                <ul className="space-y-2" data-id="element-4367">
                  <li className="flex items-center" data-id="element-4368">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4369" />
                    <span className="text-gray-700" data-id="element-4370">Science laboratories</span>
                  </li>
                  <li className="flex items-center" data-id="element-4371">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4372" />
                    <span className="text-gray-700" data-id="element-4373">
                      Library and study areas
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-4374">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4375" />
                    <span className="text-gray-700" data-id="element-4376">Sports facilities</span>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-4377">
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-4378">
                  Academic Programs
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-4379">
                  Invest in educational programs and initiatives that enhance
                  learning outcomes.
                </p>
                <ul className="space-y-2" data-id="element-4380">
                  <li className="flex items-center" data-id="element-4381">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4382" />
                    <span className="text-gray-700" data-id="element-4383">
                      STEM education programs
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-4384">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4385" />
                    <span className="text-gray-700" data-id="element-4386">
                      Digital literacy initiatives
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-4387">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4388" />
                    <span className="text-gray-700" data-id="element-4389">
                      Teacher training and development
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-4390">
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-4391">
                  Student Support
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-4392">
                  Help create opportunities for talented students from all
                  backgrounds.
                </p>
                <ul className="space-y-2" data-id="element-4393">
                  <li className="flex items-center" data-id="element-4394">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4395" />
                    <span className="text-gray-700" data-id="element-4396">Scholarship programs</span>
                  </li>
                  <li className="flex items-center" data-id="element-4397">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4398" />
                    <span className="text-gray-700" data-id="element-4399">
                      Mentorship initiatives
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-4400">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-4401" />
                    <span className="text-gray-700" data-id="element-4402">
                      Career development support
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-blue-900 text-white p-8 rounded-lg mb-16" data-id="element-4403">
          <div className="text-center mb-8" data-id="element-4404">
            <h2 className="text-3xl font-bold mb-4" data-id="element-4405">Partner Benefits</h2>
            <p className="max-w-2xl mx-auto" data-id="element-4406">
              Our corporate partners receive comprehensive benefits and
              recognition for their support.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4407">
            <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-4408">
              <h3 className="font-bold text-xl mb-4" data-id="element-4409">Brand Visibility</h3>
              <ul className="space-y-3" data-id="element-4410">
                <li className="flex items-center" data-id="element-4411">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4412" />
                  <span data-id="element-4413">Logo placement on school website</span>
                </li>
                <li className="flex items-center" data-id="element-4414">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4415" />
                  <span data-id="element-4416">Recognition in publications</span>
                </li>
                <li className="flex items-center" data-id="element-4417">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4418" />
                  <span data-id="element-4419">Event sponsorship opportunities</span>
                </li>
              </ul>
            </div>
            <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-4420">
              <h3 className="font-bold text-xl mb-4" data-id="element-4421">Employee Engagement</h3>
              <ul className="space-y-3" data-id="element-4422">
                <li className="flex items-center" data-id="element-4423">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4424" />
                  <span data-id="element-4425">Volunteer opportunities</span>
                </li>
                <li className="flex items-center" data-id="element-4426">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4427" />
                  <span data-id="element-4428">Mentorship programs</span>
                </li>
                <li className="flex items-center" data-id="element-4429">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4430" />
                  <span data-id="element-4431">Speaking engagements</span>
                </li>
              </ul>
            </div>
            <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-4432">
              <h3 className="font-bold text-xl mb-4" data-id="element-4433">Impact Reporting</h3>
              <ul className="space-y-3" data-id="element-4434">
                <li className="flex items-center" data-id="element-4435">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4436" />
                  <span data-id="element-4437">Regular progress updates</span>
                </li>
                <li className="flex items-center" data-id="element-4438">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4439" />
                  <span data-id="element-4440">Impact assessment reports</span>
                </li>
                <li className="flex items-center" data-id="element-4441">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-4442" />
                  <span data-id="element-4443">Media coverage highlights</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-4444">
          <div className="text-center mb-8" data-id="element-4445">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-4446">
              Become a Partner
            </h2>
            <p className="text-gray-700" data-id="element-4447">
              Ready to make a difference? Fill out the form below to start a
              conversation about partnership opportunities.
            </p>
          </div>
          <form className="bg-white p-8 rounded-lg shadow-md" data-id="element-4448">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-4449">
              <div data-id="element-4450">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-4451">
                  Company Name
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-4452" />
              </div>
              <div data-id="element-4453">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-4454">
                  Industry
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-4455" />
              </div>
              <div data-id="element-4456">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-4457">
                  Contact Person
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-4458" />
              </div>
              <div data-id="element-4459">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-4460">
                  Position/Title
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-4461" />
              </div>
              <div data-id="element-4462">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-4463">
                  Email
                </label>
                <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-4464" />
              </div>
              <div data-id="element-4465">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-4466">
                  Phone
                </label>
                <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-4467" />
              </div>
            </div>
            <div className="mb-6" data-id="element-4468">
              <label className="block text-gray-700 font-medium mb-2" data-id="element-4469">
                Areas of Interest
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4470">
                <label className="flex items-center" data-id="element-4471">
                  <input type="checkbox" className="mr-2" data-id="element-4472" />
                  <span data-id="element-4473">Infrastructure Development</span>
                </label>
                <label className="flex items-center" data-id="element-4474">
                  <input type="checkbox" className="mr-2" data-id="element-4475" />
                  <span data-id="element-4476">Academic Programs</span>
                </label>
                <label className="flex items-center" data-id="element-4477">
                  <input type="checkbox" className="mr-2" data-id="element-4478" />
                  <span data-id="element-4479">Student Support</span>
                </label>
                <label className="flex items-center" data-id="element-4480">
                  <input type="checkbox" className="mr-2" data-id="element-4481" />
                  <span data-id="element-4482">Other</span>
                </label>
              </div>
            </div>
            <div className="mb-6" data-id="element-4483">
              <label className="block text-gray-700 font-medium mb-2" data-id="element-4484">
                Message
              </label>
              <textarea rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tell us about your partnership interests and goals..." required data-id="element-4485"></textarea>
            </div>
            <Button type="submit" variant="primary" className="w-full" data-id="element-4486">
              Submit Partnership Inquiry
            </Button>
          </form>
        </div>
      </div>
    </div>;
};
export default CorporatePartnerships;